export function scrollToId(id, offset = -72) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset, duration: 1.0 });
  else el.scrollIntoView({ behavior: "smooth" });
}
